import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Toaster } from 'sonner';
import { Menu } from 'lucide-react';

const LOGO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_sales-analytics-base/artifacts/bju11je1_Final%20Logo-01.webp";

export default function Layout() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    // close sidebar whenever route changes on mobile
    useEffect(() => { setMobileOpen(false); }, [location.pathname]);

    return (
        <div className="min-h-screen flex bg-[#F5F7FA] text-[#0F172A]">
            <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

            {/* Backdrop when sidebar open on mobile */}
            {mobileOpen && (
                <div
                    className="fixed inset-0 z-30 bg-black/60 backdrop-blur-sm md:hidden"
                    onClick={() => setMobileOpen(false)}
                    data-testid="sidebar-backdrop"
                />
            )}

            <div className="flex-1 min-w-0 flex flex-col">
                {/* Mobile top bar */}
                <div className="md:hidden sticky top-0 z-20 flex items-center gap-3 px-4 py-3 bg-[#043e52] border-b border-[#043e52]">
                    <button
                        onClick={() => setMobileOpen(true)}
                        data-testid="btn-mobile-menu"
                        aria-label="Open menu"
                        className="p-2 -ml-2 rounded-md text-white/80 hover:text-white hover:bg-white/10"
                    >
                        <Menu className="w-5 h-5" />
                    </button>
                    <img
                        src={LOGO_URL}
                        alt="Ikas Corp"
                        className="h-7 w-auto brightness-0 invert"
                    />
                    <span className="text-[10px] uppercase tracking-[0.2em] text-white/60 ml-auto">Sales CRM</span>
                </div>

                <main className="flex-1 overflow-x-hidden" data-testid="main-content">
                    <Outlet />
                </main>
            </div>

            <Toaster theme="light" position="top-right" />
        </div>
    );
}
